import React from 'react';
import BookingFlow from './BookingFlow';

export default function BookingPage() {
  return (
    <BookingFlow
      title="Book a Consultation"
      subtitle="Free 60-minute intro call — pick a time that works for you."
      slotsPath="/booking/slots"
      bookPath="/booking"
      backLinkText="← Back to login"
      submitLabel="Confirm Booking"
      confirmedBackText="← Back to login"
    />
  );
}
